import { endpoint } from 'services/Api';
import { RESOURCE as PARENT } from 'services/api/calculatorModals';

/**
 * Resource Endpoint.
 *
 * @type {String}
 */
export const RESOURCE = 'pension';

/**
 * Care Modal Endpoints:
 *     - Pension Multiplier.
 */
export default {
    /**
     * Personal Injury Pension Multiplier Calculation Modal Endpoint.
     *
     * @return {Promise}
     */
    pensionLossMultiplier: data => endpoint(`${PARENT}/${RESOURCE}`, 'pension-multiplier', data),
    /**
     * Personal Injury Lump SUm Multiplier Calculation Modal Endpoint.
     *
     * @return {Promise}
     */
    lumpSumMultiplier: data => endpoint(`${PARENT}/${RESOURCE}`, 'pension-loss', data)
};



// WEBPACK FOOTER //
// ./src/services/api/calculatorModals/pension.js